import { render, staticRenderFns } from "./DsfrTextarea.vue?vue&type=template&id=a7fdf70a&scoped=true&"
import script from "./DsfrTextarea.vue?vue&type=script&lang=js&"
export * from "./DsfrTextarea.vue?vue&type=script&lang=js&"
import style0 from "./DsfrTextarea.vue?vue&type=style&index=0&id=a7fdf70a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7fdf70a",
  null
  
)

export default component.exports